module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.6 30.4"><defs><path id="a" d="M0 0h17.6v30.4H0z"/></defs><path class="st0" d="M16.7 29.4c-1.5 1.6-3.2.1-4.4-1-1-1-2.3-2.2-3.3-3.1-2.8 2.9-5.1 6.5-7.4 4.5-2.7-2.3 2.6-5.8 4-7.8-1.3-.3-3.6-1-4.7-1.8s-1.3-2.7 0-3.7c1.6-1.1 2.6.1 4.5.7 7.1 2.3 9.8-4.1 11.9-.4 1.8 3.2-4.3 4.6-5 5.1 2.9 2.8 6.6 5.3 4.4 7.5"/><path class="st0" d="M9.7.1C5.9-.5 1.3 1.8.6 6.5-1 16.8 14.7 19.3 16.1 8.9 16.7 5 14.2.9 9.7.1M8.5 11c-4.3 0-4.6-6.1-.3-6.4 4.5-.3 4.5 6.3.3 6.4"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ok.svg
// module id = 23
// module chunks = 0